import type { ReactElement } from "react"
import { Anchor } from "@/app/components/anchor"
import { getBoatLink, getBreedLink } from "@/util/getBreedUrl"
import { getCityUrl } from "@/util/getCityUrl"
import { parseBoatTripName, parsePetName } from "@/util/string"

interface RecentTripNameProps {
  category: string
  name: string
}

function PetTripName({ name }: { name: string }): ReactElement {
  const trip = parsePetName(name)

  if (!trip) {
    return (
      <Anchor href="/pet-shipping" className="hover:underline">
        {name}
      </Anchor>
    )
  }

  const breedUrl = getBreedLink(trip.breed)
  const fromUrl = getCityUrl(trip.fromLocation)
  const toUrl = getCityUrl(trip.toLocation)

  return (
    <>
      {trip.prefix ? trip.prefix : trip.weight}
      {"  "}
      {breedUrl ? (
        <Anchor href={breedUrl} className="hover:underline">
          {trip.breed}
        </Anchor>
      ) : (
        trip.breed
      )}
      {" from "}
      {fromUrl ? (
        <Anchor href={fromUrl} className="hover:underline">
          {trip.fromLocation}
        </Anchor>
      ) : (
        trip.fromLocation
      )}
      {" to "}
      {toUrl ? (
        <Anchor href={toUrl} className="hover:underline">
          {trip.toLocation}
        </Anchor>
      ) : (
        trip.toLocation
      )}{" "}
      {trip.suffix}
    </>
  )
}

function BoatTripName({ name }: { name: string }): ReactElement {
  const trip = parseBoatTripName(name)

  if (!trip) {
    return <span>{name}</span>
  }

  const fromUrl = getBoatLink(trip.fromLocation)
  const toUrl = getBoatLink(trip.toLocation)

  return (
    <>
      {trip.boat}
      {" from "}
      {fromUrl ? (
        <Anchor href={fromUrl} className="hover:underline">
          {trip.fromLocation}
        </Anchor>
      ) : (
        trip.fromLocation
      )}
      {" to "}
      {toUrl ? (
        <Anchor href={toUrl} className="hover:underline">
          {trip.toLocation}
        </Anchor>
      ) : (
        trip.toLocation
      )}
      <span className="px-1"> {trip.suffix}</span>
    </>
  )
}

export function RecentTripName({
  category,
  name,
}: RecentTripNameProps): ReactElement {
  if (category === "Pets and Animals") {
    return <PetTripName name={name} />
  }

  if (category === "Boats and Water Vehicles") {
    return <BoatTripName name={name} />
  }

  return <>{name}</>
}
